import { FC } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { TableContainer, Spinner, ScreenOverlay } from "../../../../components/Common";
import usePagination from "../../../../common/hooks/pagination";
import { toastError } from "../../../../helpers/toast-helper";
import { getResponseData } from "../../../../helpers/response-helper";

import { COLUMNS } from "../../config";
import {useJobListByRole} from "./helper";
import { useNavigate } from "react-router-dom";

interface Props {
    isAdmin: boolean;
    userId: string | number;
}

const JobsList: FC<Props> = ({ isAdmin, userId }) => {
    const {
        pagination,
        setPagination,

        sorting,
        setSorting,

        globalFilter,
        setGlobalFilter,

        params,

        getPageCount,
    } = usePagination();

    const navigate = useNavigate();

    const { data: jobList, isLoading } = useJobListByRole(isAdmin)({
        ...params,
        userId,
    }, {
        onError: () => {
            toastError("Cannot fetch jobs");
        }
    });

    const { data, meta } = getResponseData(jobList);

    const pageCount = getPageCount(meta);

    return (
        <Row>
            <Col lg="12">
                <Card>
                    <CardBody>
                        <TableContainer
                            columns={COLUMNS}
                            data={data || []}
                            isGlobalFilter={true}
                            isPagination={true}
                            SearchPlaceholder="Search..."
                            isCustomPageSize={true}
                            isAddButton={false}
                            buttonName="New Quote"
                            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                            theadClass="table-light"
                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                            pagination="pagination"

                            manualPagination
                            paginationState={pagination}
                            onPaginationChange={setPagination}
                            pageCount={pageCount}

                            manualSorting
                            sortingState={sorting}
                            onSortingChange={setSorting}

                            manualGlobalFilter={true}
                            globalFilterState={globalFilter}
                            onGlobalFilterChange={setGlobalFilter}

                            onRowClick={(rowData) => {
                                navigate(`/jobs/${rowData.id}`);
                            }}
                        />
                    </CardBody>
                </Card>
            </Col>
            {isLoading && (
                <>
                    <ScreenOverlay />
                    <Spinner />
                </>
            )}
        </Row>
    );
};

export default JobsList;
